<template>
    <div>
        <el-page-header @back="goBack" content="商城标签管理"></el-page-header>
        <el-card class="form-container" shadow="never" style="margin-top: 10px">
            <div style="font-size: 18px; color: black;">商城标签修改及设置</div>
            <el-table border :data="classifyList"  :header-cell-style="{background:'#606266'}"  height="250" style="margin-top: 10px">
                <el-table-column label="id"   align="center" width="200px" >
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.id" v-if="scope.row.id==0 "></el-input-number>
                        <el-input v-model="scope.row.id" v-else :disabled="true"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="分类名称"  align="center" width="200px" >
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.name"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="分类排序"  align="center" width="220px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.rank"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="操作"  align="center" width="200px">
                    <template slot-scope="scope">
                        <el-button plain size="mini" type="success" v-if="scope.row.id!==1" @click="jumpSubShelvesManage(scope.row)">编辑子分类</el-button> 
                    </template>
                </el-table-column>
            </el-table>
            <div style="margin-top: 10px;left: 80% ;position:relative">
                <el-button size="mini" type="primary" @click="addClassify">新增条目</el-button>
                <el-button size="mini" type="success" @click="updateClassifyList">更新修改</el-button>
            </div>
        </el-card>
        <el-card class="form-container" shadow="never" style="margin-top: 10px">
            <el-form :inline="true"  size="small" label-width="140px">
                <el-form-item label="分类内商品排序设置：" label-width="180px" >
                    <el-select v-model="classifyId" placeholder="请选择"  >
                        <el-option label="全部" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label=" " class="sub-sub11" >
                    <el-button type="primary" @click="queryShelves">查询</el-button>
                </el-form-item>
            </el-form>
            <el-table border :data="shelvesList"  :header-cell-style="{background:'#606266'}"  height="330" style="margin-top: 10px">
                <el-table-column label="序号ID" prop="id" align="center"></el-table-column>
                <el-table-column label="商品名称" prop="name" align="center"></el-table-column>
                <el-table-column label="物品类型" prop="cid" align="center"></el-table-column>
                <el-table-column label="当前价格" prop="currentPrice" align="center"></el-table-column>
                <el-table-column label="商品排序" prop="rank" align="center"></el-table-column>
                <el-table-column label="操作"  align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="getTopMove(scope.row,scope.$index)" :disabled="scope.$index==0">
                            置顶
                        </el-button>
                        <el-button type="text" size="small" @click="getUpMove(scope.row,scope.$index)" :disabled="scope.$index==0">
                            上移
                        </el-button>
                        <el-button type="text" size="small" @click="getDownMove(scope.row,scope.$index)"
                                   :disabled="shelvesList.length-1==scope.$index">下移
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>

        </el-card>
    </div>
</template>

<script>
    import {
        shopSelections,
        classifyUpdate,
        shelvesListByClassifyId,
        updateShelvesRank
    } from "@/http/cgApi";
    export default {
        name: "CgShelvesManage",
        data(){
            return{
                classifyList:[],
                classifyId : 1,
                shelvesList :[]
            }
        },
        methods:{
            goBack() {
                this.$router.push({ path: '/cgShopManage'});
            },
            getSelections(){
                shopSelections().then(resp => {
                    this.classifyList = resp.data.info.classifyList;
                })
            },
            updateClassifyList(){
                classifyUpdate(this.classifyList).then(resp => {
                    if (resp.data.status === 0){
                        this.getSelections();
                    }
                })
            },
            queryShelves(){
                shelvesListByClassifyId(this.classifyId).then(resp => {
                    this.shelvesList = resp.data.info
              })
            },
            getTopMove(row, index) {
                this.shelvesList.splice(index, 1);
                this.shelvesList.unshift(row)
                this.batchUpdateRank()
            },
            //上移
            getUpMove(row, index) {
                let arr = this.shelvesList;
                arr.splice(index - 1, 1, ...arr.splice(index, 1, arr[index - 1]));
                this.batchUpdateRank()
                },
            //下移
            getDownMove(row, index) {
                let arr = this.shelvesList;
                arr.splice(index, 1, ...arr.splice(index + 1, 1, arr[index]));
                this.batchUpdateRank()
                },
            batchUpdateRank(){
                updateShelvesRank(this.shelvesList).then(resp => {
                    if (resp.data.status === 0){
                        this.queryShelves();
                    }
                })
            },
            jumpSubShelvesManage(row){
                this.$router.push({ path: '/cgSubShelvesManage',query:{classifyId:row.id}});
            },
            addClassify(){
                let arr = this.classifyList;
                arr.push({id:0,name:"",rank:0,parentId:null})
            }
         },
        created() {
            this.getSelections();
            this.queryShelves();
        },

    }
</script>

<style scoped>

</style>
